/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

const StyledSVG = styled.svg`
  .cls-1 {
    fill: ${(props) => props.theme.palette.highlight.main};
  }
  .cls-2 {
    fill: ${(props) => props.theme.palette.common.white};
  }
`;
export const SVG = ({ className }: { className?: string }) => (
  <StyledSVG className={className} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 139.43 29.6'>
    <defs />
    <g id='Ebene_2' data-name='Ebene 2'>
      <g id='Ebene_1-2' data-name='Ebene 1'>
        <g id='aero' className='cls-1'>
          <g className='cls-1'>
            <path
              className='cls-2'
              d='M18.24,27.4c0,1.56-.88,2.2-2.44,2.2a3.58,3.58,0,0,1-3.68-2.16H12A8.84,8.84,0,0,1,6,29.6c-3.56,0-6-1.8-6-5.64,0-4.36,2.52-6.08,7.44-6.28l4.4-.2v-5.8a10.32,10.32,0,0,0-4.48-1,13.53,13.53,0,0,0-4.92.88A10.89,10.89,0,0,1,2,8.72a18,18,0,0,1,5.4-.8c2.68,0,5.68.6,7.4,2V25.16c0,1,.28,1.32,1.2,1.32h2.2Zm-6.4-7.56L7.32,20c-3.08.12-4,1.12-4,3.72,0,2.28,1,3.2,3.32,3.2a9.53,9.53,0,0,0,5.24-1.72Z'
            />
            <path
              className='cls-2'
              d='M37.52,19.36H25.08v.2c0,4.8,1.48,7.08,6.08,7.08a11.07,11.07,0,0,0,5.28-1.36,17.45,17.45,0,0,1,.8,2.92A13,13,0,0,1,31,29.6c-6.12,0-9.36-3.44-9.36-10.56,0-7.8,3.64-11.12,8.4-11.12,4.92,0,7.56,3,7.56,8.28C37.64,17.08,37.6,18.4,37.52,19.36Zm-12.4-2.44h9.36c0-.32,0-1,0-1.28,0-3.68-1.68-5.16-4.52-5.16S25.24,12.28,25.12,16.92Z'
            />
            <path
              className='cls-2'
              d='M53.76,11.36a7.22,7.22,0,0,0-1.8-.2c-1.44,0-2.88.24-4.8,2.28V29.2H44V8.48a19.36,19.36,0,0,1,3.12-.24v2.64h.16c2.36-2.72,3.8-3,5.12-3a5.93,5.93,0,0,1,1.64.2A22.22,22.22,0,0,1,53.76,11.36Z'
            />
            <path
              className='cls-2'
              d='M66.44,29.6c-5.24,0-8.72-3.16-8.72-10.84,0-7,3.68-10.84,8.92-10.84s8.76,3.16,8.76,10.84C75.4,26.12,71.52,29.6,66.44,29.6Zm.16-19c-3.16,0-5.52,1.72-5.52,8.12,0,6.2,2,8.12,5.44,8.12,3.16,0,5.52-1.72,5.52-8.12C72,12.56,70,10.64,66.6,10.64Z'
            />
          </g>
        </g>
        <g id='sim' className='cls-1'>
          <g className='cls-1'>
            <path
              className='cls-2'
              d='M87.4,29.6A14.23,14.23,0,0,1,81,28.16,34.57,34.57,0,0,1,82.08,24a14.18,14.18,0,0,0,6.12,1.4c1.8,0,2.52-.8,2.52-2.12,0-3.48-9.48-1.76-9.48-8.68,0-4.52,3.92-6.72,8.4-6.72a21.21,21.21,0,0,1,5,.64A22.47,22.47,0,0,1,94,12.68a20.21,20.21,0,0,0-5.52-.8c-1.68,0-2.48.76-2.48,2.2,0,3.24,9.4,1.56,9.4,9C95.44,27.64,91.56,29.6,87.4,29.6Z'
            />
            <path
              className='cls-2'
              d='M103.08,5.44a2.48,2.48,0,0,1-2.56-2.68,2.6,2.6,0,1,1,5.2,0A2.51,2.51,0,0,1,103.08,5.44ZM100.84,29.2V8.32h4.56V29.2Z'
            />
            <path
              className='cls-2'
              d='M134.88,29.2V14.72C134.88,13,134.2,12,132,12a5.92,5.92,0,0,0-3.84,1.36V29.2h-4.56V14.76c0-1.76-.68-2.8-2.76-2.8A6.56,6.56,0,0,0,117,13.32V29.2H112.4V8.48A41.05,41.05,0,0,1,117,8.2v2.08h.24c1.92-1.72,3.36-2.36,5.4-2.36a4.66,4.66,0,0,1,4.68,2.72,7.93,7.93,0,0,1,6.12-2.72c3.39,0,6,1.76,6,6.4V29.2Z'
            />
          </g>
        </g>
      </g>
    </g>
  </StyledSVG>
);
export default SVG;
